import React from "react";
import TopoTexture from "@/components/TopoTexture";
import { Star, Quote, MapPin } from "lucide-react";
import { TESTIMONIALS, COMPANY } from "@/data/site";

const ReviewsSection = () => {
  return (
    <section data-testid="reviews-section" className="relative py-20 md:py-32 bg-[var(--ct-bg)] overflow-hidden">
      <TopoTexture variant="light" />
      <div className="section-container relative">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="label-xs text-[var(--ct-primary)] mb-3">Customer Reviews</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
              Rated {COMPANY.rating} stars by Wyoming families & businesses.
            </h2>
            <a
              href={COMPANY.googleMaps}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Find Crosstown Movers on Google Maps"
              data-testid="reviews-google-link"
              className="inline-flex items-center gap-2 mt-5 px-4 py-2.5 rounded-full border border-[var(--ct-border)] bg-white text-sm font-semibold text-[var(--ct-primary)] hover:border-[var(--ct-primary)] focus-visible:outline-2 focus-visible:outline-[var(--ct-primary)] transition"
            >
              <MapPin className="w-4 h-4 text-[var(--ct-secondary)]" /> Find us on Google
            </a>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex">
              {[1,2,3,4,5].map((i) => (
                <Star key={i} className={`w-5 h-5 ${i <= 4 ? 'fill-[var(--ct-secondary)] text-[var(--ct-secondary)]' : 'text-[var(--ct-secondary)]'}`} />
              ))}
            </div>
            <div className="text-sm text-[var(--ct-text-muted)]">
              <strong className="text-[var(--ct-primary)]">{COMPANY.rating}</strong> · {COMPANY.reviews} reviews
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-[var(--ct-accent)] rounded-2xl p-7 border border-[var(--ct-border)]"
            >
              <Quote className="w-10 h-10 text-[var(--ct-primary)]/20 absolute top-5 right-5" />
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    className={`w-4 h-4 ${j < t.rating ? 'fill-[var(--ct-secondary)] text-[var(--ct-secondary)]' : 'text-[var(--ct-secondary)]/30'}`}
                  />
                ))}
              </div>
              <p className="text-[var(--ct-text)] leading-relaxed">"{t.text}"</p>
              <div className="mt-5 pt-5 border-t border-[var(--ct-primary)]/10">
                <div className="font-semibold text-[var(--ct-primary)]">{t.name}</div>
                <div className="text-xs text-[var(--ct-text-muted)]">{t.location}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
